import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  // Sidebar collapse state - starts collapsed (showing only icons)
  isCollapsed = signal<boolean>(true);

  // Pin state - when true, sidebar stays open and hover is disabled
  isPinned = signal<boolean>(false);

  /**
   * Toggle sidebar collapse state
   */
  toggleCollapse(): void {
    this.isCollapsed.update((value) => !value);
    this.isPinned.set(!this.isCollapsed());
  }

  /**
   * Collapse sidebar
   */
  collapse(): void {
    this.isCollapsed.set(true);
  }

  /**
   * Expand sidebar
   */
  expand(): void {
    this.isCollapsed.set(false);
  }

  /**
   * Set pin state
   */
  setPinned(pinned: boolean): void {
    this.isPinned.set(pinned);
  }
}
